module.exports = __webpack_public_path__ + "img/audiobg.png";